import { ReactNode } from 'react'

import { Image } from 'antd-mobile'

import { INovelDetail } from '@/api'

import Icon from '../Icon'
import { cn } from '@/utils'

interface PropsIn {
  data: INovelDetail
  className?: string
  badge?: ReactNode
  pictureClassName?: string
  infoClassName?: string
  options?: ReactNode
  extra?: boolean | React.ReactElement
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

/**
 * 书籍卡片
 * @param data 数据项
 * @param index 数据索引
 * @param className 根类名
 * @param badge 角标
 * @param pictureClassName 图片盒子类名
 * @param infoClassName 右侧信息内容盒子类名
 * @returns
 */
const BookCard = (props: PropsIn) => {
  const { data, className, badge, options, pictureClassName, infoClassName, extra = true, onClick } = props

  const dataNotFound = (Array.isArray(data) && data.length === 0) || !data || Object.keys(data).length === 0 || !data.resource_id

  return (
    <div className={cn('flex h-[138px] w-[433px]', className)} onClick={onClick}>
      <div className={cn('relative h-[122px] w-[90px] shrink-0 overflow-hidden rounded-[7px]', pictureClassName)}>
        {dataNotFound ? (
          <Icon name='TakeDown' width='100%' height='100%' />
        ) : (
          <Image
            src={(data as unknown as Record<string, string>)?.cover_pic_url}
            fit='cover'
            width='100%'
            height='100%'
            alt={dataNotFound ? 'notFound' : (data as unknown as Record<string, string>)?.name}
            placeholder={<Icon name='DefaultCover' width={'100%'} height={'100%'} />}
            fallback={<Icon name='DefaultCover' width={'100%'} height={'100%'} />}
          />
        )}

        {badge ? badge : null}
      </div>
      <div className={cn('mb-auto ml-[22px] mr-[4px] mt-[21px] flex w-[317px] flex-col text-base-text-color', infoClassName)}>
        <span className={cn('mb-[7px] line-clamp-1 font-geologica text-[26px] font-normal leading-[41px]')}>
          {dataNotFound ? 'Content Removed' : (data as unknown as Record<string, string>)?.name}
        </span>
        {dataNotFound ? null : extra ? (
          typeof extra === 'boolean' ? (
            <span className={cn('line-clamp-1 h-[30px] break-all font-geologica text-[22px] font-light leading-[30px] text-color-white-trans40')}>
              {(data as unknown as Record<string, string>)?.author_name}
            </span>
          ) : (
            extra
          )
        ) : null}
      </div>
      {options ? options : null}
    </div>
  )
}

export default BookCard
